import * as React from 'react';

function ArrowUpIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className="arrowUpIcon"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="6d4ej6yhsa"
          d="M1.629 13.929C.68 12.292.124 10.459 0 8.57 0 3.838 3.838 0 8.571 0c2.463-.012 4.81 1.048 6.429 2.904C16.62 1.048 18.966-.012 21.429 0 26.162 0 30 3.838 30 8.57c-.124 1.888-.681 3.72-1.629 5.358h-5.067L21.429 7.21c-.123-.44-.51-.754-.965-.782-.463-.035-.896.234-1.071.664l-4.532 10.81-4.286-7.714c-.187-.346-.55-.562-.943-.562-.394 0-.756.216-.943.562l-1.853 3.74H1.629zM22.5 16.07c-.495.019-.938-.305-1.071-.782l-1.265-4.575-4.178 10.029c-.155.38-.513.637-.922.664H15c-.387 0-.743-.21-.932-.546l-4.372-7.875-1.242 2.496c-.182.36-.55.588-.954.59H2.86c3.31 4.922 7.123 9.486 11.38 13.617.2.203.474.317.76.317.286 0 .56-.114.76-.317 4.257-4.13 8.07-8.695 11.38-13.618H22.5z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path d="M0 0H40V40H0z" transform="translate(-224 -468) translate(156 448) translate(68 20)" />
              <g transform="translate(-224 -468) translate(156 448) translate(68 20) translate(5 5)">
                <mask id="rqc85qsh3b" fill="#fff">
                  <use xlinkHref="#6d4ej6yhsa" />
                </mask>
                <use fill="#000" fillRule="nonzero" xlinkHref="#6d4ej6yhsa" />
                <g fill="#1AAADC" mask="url(#rqc85qsh3b)">
                  <path d="M0 0H40V40H0z" transform="translate(-5 -5)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowUpIcon;
